<script>
  import AccompanyingEvent from './AccompanyingEvent.svelte';
  import SeparatorHorizontal from './SeparatorHorizontal.svelte';
  import Common from '../js/common.js';

  export let accompanyingEvents;
  export let lang = undefined;

  const accompanyingEventsFuture = Common.sortArrayOfObjectsByKey(
    accompanyingEvents.filter(accompanyingEvent => Common.formatDbDate(accompanyingEvent.to.date || accompanyingEvent.from.date) >= Common.getDbDate()),
    ['from.date'],
  );

  const accompanyingEventsPast = Common.sortArrayOfObjectsByKey(
    accompanyingEvents.filter(accompanyingEvent => Common.formatDbDate(accompanyingEvent.to.date || accompanyingEvent.from.date) < Common.getDbDate()),
    ['from.date'],
    true,
  );
</script>

<div class='accompanying-events-box'>
  {#if accompanyingEventsFuture.length > 0}
    {#each accompanyingEventsFuture as event}
      <AccompanyingEvent value={event} bind:lang/>
    {/each}
  {/if}

  {#if accompanyingEventsFuture.length > 0 && accompanyingEventsPast.length > 0}
    <SeparatorHorizontal/>
  {/if}

  {#if accompanyingEventsPast.length > 0}
    {#each accompanyingEventsPast as event}
      <AccompanyingEvent value={event} bind:lang/>
    {/each}
  {/if}
</div>

<style>
  .accompanying-events-box {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    padding: 20px;

    border-radius: 5px;

    background: var(--grey-1);
  }

  :global(body.dark) .accompanying-events-box {
    background: var(--grey-8);
  }
</style>
